
import React, { Component , useEffect, useState } from 'react';
import { isEmpty } from "lodash";
import { Button, Box, FormControlLabel, Switch, Grid } from '@material-ui/core';
// import InputText, { TextArea } from '../../../commonModules/interface/form-input-inline.jsx';
import { toast } from 'react-toastify';
import InputText, { InputSelectNative, TextArea } from '../../../../commonModules/interface/form-input-inline';
import Dialog from '../../../../commonModules/interface/Dialog';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';

const NewBin = (props) => {
    const [state, setState] = useState({ 
        bin: props.bin || {
            bin_name: "",
            // ref: "",
            bin_type: "",
            bin_share_id:"",
            bin_longueur: "",
            largeur: "",
            bin_hauteur: "",
            bin_tare: "",
        },
        errors:{
            bin_name: "",
            // ref: "",
            bin_type: "",
            bin_longueur: "",
            bin_largeur: "",
            bin_hauteur: "",
            bin_tare: "",
        },
        floatFields : [
            "bin_longueur",
            "bin_largeur",
            "bin_hauteur",
            "bin_tare"
        ],
        preview: false,
     })
     const [bacConnexion, setBacConnexion] = useState('bac_personnal');

     const handleChangeBac = (event) => {
        setBacConnexion(event.target.value);
     };

    const handleChange = (e) => { 
        const { name, value } = e.target

        setState(prevState => ({...prevState,
            bin : {
                ...state.bin,
                [name] : value
            }
        }))
    }

    const setPhotos = (list) => {
        console.log("[INFO] SETPHOTOS", list);
        
        setState(prevState => ({...prevState,
            bin:{
                ...state.bin,
                photo:list
            }
        }))
    }
    
    const createBinList= () =>{ 
        const types = {
            "panneaux": "Panneaux Solaires",
            "plastic": "Plastique",
            "electronics": "Dechet Électroniques",
            "lithium": "Batteries Lithium",
            "plomb": "Batteries Plomb",
            "cable": "Cable",
            "other": "Tout Venant",
        }
        // return Object.keys(types).map((key) => (        
        //     {value: key, label:types[key] }
        // ))
        return Object.keys(types).map((key) => {
            return (        
                <option key={key} value={key} >{types[key]}</option>
            )
        })
    }

    const validate = () => {
        let noErrors = true
        let errors = {}
        let newBin = Object.assign({}, state.bin)
        const { floatFields } = state
        floatFields.map( field => {
            newBin[field] = parseFloat(newBin[field])
        })
        
        Object.keys(state.errors).map( field => {
            if( isEmpty(newBin[field]) && !newBin[field] ){ // input is empty  
                noErrors = false
                errors[field] = "Veuillez remplir ce champ"
            } else {
                errors[field] = ""   
            }
        })

        console.log("[INFO] NOERRORS = ",noErrors);
        console.log("[INFO] VALIDATE, ERRORS = ",errors);
        if (bacConnexion === "bac_shared" &&  state.bin.bin_share_id.length === 13 ){
            noErrors = true
        }
        setState(prevState => ({...prevState,
            errors : errors,
            preview: noErrors,
        }))

        return noErrors
    }

    const handleSubmit = async () => {
        if(validate()){

            let newBin = Object.assign({}, state.bin)
            // newBin.bin_ref = createRef()
   
            const { floatFields } = state

            floatFields.map( field => {
                newBin[field] = parseFloat(newBin[field])
            })
            newBin["bac_type"] = parseFloat(bacConnexion)

            try{
                const resp =  await props.createBin(newBin)
                toast.success("Le bac a été créé avec succès")
                props.handleUpdate()
                props.closeAll()
            }catch(err){
                toast.error("ERROR"+err.message)
            }         
        } else {
            toast.error( "Le formulaire contient des erreurs")
        }
    }

    const handleSubmitUpdate = async () => {
        if( validate()){
            let newBin = Object.assign({}, props.bin, state.bin)
            const { floatFields } = state

            floatFields.map( field => {
                newBin[field] = parseFloat(newBin[field])
            })

            try{
                await props.updateBin(newBin)

                // if(props.STATE.bins.error){                    
                //     toast.error( props.STATE.bins.error.message)
                // } else {

                //     toast.success( "Le bac a été modifié avec succès")
                //     props.closeAll()
                // }
                
            } catch(err){
                console.log("[ERROR] SUBMIT UPDATE ", err);
                toast.error("Un Problème est survenu")
            }
        }
    }

        return (
            <Dialog
                title="Nouveau bac de recyclage"
                block={true}
                close={props.closeAll}
                submitAction={props.update ? handleSubmitUpdate : handleSubmit}
            >
                <Box p={2}>
                    {/* <Box p={1}>

                        <FormControlLabel
                            control={
                                <Switch
                                    checked={state.bin.bin_disabled}
                                    onChange={(e) => setState({
                                        ...state,
                                        bin : {
                                            ...state.bin,
                                            bin_disabled: e.target.checked
                                        } 
                                    })}
                                    name="bin_disabled"
                                    color="primary"
                                    labelPlacement="right"
                                />
                            }
                            label="Bac Désactivé"
                        />
                    </Box> */}

                <FormLabel component="legend">Type de client</FormLabel>
                    <RadioGroup aria-label="client_type" name="client_type" value={bacConnexion} onChange={handleChangeBac}>
                        <FormControlLabel value="bac_personnal" control={<Radio />} label="Bac personnel" />
                        <FormControlLabel value="bac_shared" control={<Radio />} label="Bac partageée" />
                    </RadioGroup>
                    { bacConnexion === "bac_shared" &&
                        <InputText 
                            name="bin_share_id" 
                            value={state.bin.bin_share_id} 
                            error={state.errors.bin_share_id} 
                            change={handleChange} 
                            title="Id du bac (13)" 
                            required 
                        />
                    }
                    { bacConnexion === "bac_personnal" &&
                    <>
                    <InputText type="text" id="bin_name" change={handleChange} value={state.bin.bin_name} error={state.errors.bin_name} name="bin_name" placeholder="Nom du Bac"/>
                            
                    <InputSelectNative
                        label="Type de Bac"
                        name="bin_type"
                        value={state.bin.bin_type}
                        error={state.errors.bin_type}
                        change={handleChange}
                        required
                        options={createBinList()}
                    />
                    <InputText 
                        name="bin_tare" 
                        value={state.bin.bin_tare} 
                        error={state.errors.bin_tare} 
                        change={handleChange} 
                        title="Poids (Kg)" 
                        required 
                    />
                    <Grid container spacing={1}>
                        {/* <Grid item xs={12}>
                            <Typography variant="subtitle1">Dimensions (LxlxH) *</Typography>
                        </Grid> */}
                        <Grid item xs={12} sm={4}>
                            <InputText
                                change={handleChange} 
                                value={state.bin.bin_largeur} 
                                name="bin_largeur" 
                                title="Largeur (m)" 
                                required 
                                error={state.errors.bin_largeur}
                                type="number"
                            />
                        </Grid>
                        
                        <Grid item xs={12} sm={4}>
                            <InputText
                                change={handleChange} 
                                value={state.bin.bin_longueur} 
                                name="bin_longueur" 
                                title="Longueur (m)" 
                                required 
                                error={state.errors.bin_longueur}
                                type="number"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <InputText
                                change={handleChange} 
                                value={state.bin.bin_hauteur} 
                                name="bin_hauteur" 
                                title="Hauteur (m)" 
                                required 
                                error={state.errors.bin_hauteur}
                                type="number"
                            />
                        </Grid>                        
                    </Grid>
                    </>}
                    {/* +++ "Share Bin with other account" */}
                    {/* <Box p={1}>
                        <Button 
                            variant="contained"
                            color="primary"
                            onClick={ validate }
                        >
                            Valider
                        </Button>
                    </Box> */}
                                  
                </Box>
            </Dialog>
        );
}

export default NewBin;

 